import { StoreType } from 'types/store'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { saveStoreConfirmAction } from 'reducks/confirm/actions'
import { push } from 'connected-react-router'

const saveStoreConfirm = (store: StoreType, storeId: string, isEditedByOwner: boolean) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(saveStoreConfirmAction(store))
    const query = getState().store.is_mellow ? '?store_type=retailer' : ''
    if (isEditedByOwner) {
      dispatch(push('/account/information/confirm' + query))
    } else {
      dispatch(push(`/admin/shops/${storeId}/information/confirm` + query))
    }
  }
}

export default saveStoreConfirm
